export default __webpack_public_path__ + "static/media/photo-09.0b6ee1e7.jpeg";